import { Image, StyleSheet, Text, View, ViewStyle } from "react-native";
import { Colors, Typography } from "../../../styles";
import Divider from "../Divider";
import { Ionicons } from "@expo/vector-icons";

const Profile = ({
  image,
  name,
  notifications,
  type,
  style,
}: {
  image: string;
  name: string;
  notifications: number;
  type?: "main" | "secondary";
  style?: ViewStyle;
}) => {
  return (
    <View style={[styles.row, style]}>
      <Image source={{ uri: image }} style={styles.profileImage} />
      <View>
        <Text
          style={[
            styles.profileText,
            type === "main"
              ? Typography.weightMedium
              : Typography.weightRegular,
          ]}
        >
          {name}
        </Text>
        {notifications !== 0 && (
          <View style={styles.row}>
            <View style={styles.notificationIcon} />
            <Text style={styles.notificationsText}>
              {notifications} notifications
            </Text>
          </View>
        )}
      </View>
    </View>
  );
};

const Profiles = () => {
  return (
    <View style={styles.container}>
      <Profile
        image={
          "https://images.unsplash.com/photo-1597223557154-721c1cecc4b0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80"
        }
        name={"Janette Paul"}
        notifications={0}
        type={"main"}
      />
      <Divider style={{ marginVertical: 15 }} />
      <Profile
        image={
          "https://images.unsplash.com/photo-1554151228-14d9def656e4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=686&q=80"
        }
        name={"Samantha Jones"}
        notifications={5}
        type={"secondary"}
        style={{ marginBottom: 15 }}
      />
      <Profile
        image={
          "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80"
        }
        name={"Jimmy Jones"}
        notifications={0}
        type={"secondary"}
        style={{ marginBottom: 20 }}
      />

      <View style={styles.row}>
        <Ionicons
          name="md-person-add"
          size={20}
          color={Colors.plum400}
          style={{ marginRight: 10 }}
        />
        <Text style={[Typography.paragraph, { color: Colors.plum300 }]}>
          Manage accounts
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {},
  row: { flexDirection: "row", alignItems: "center" },
  profileText: {},
  profileImage: { width: 40, height: 40, borderRadius: 40 / 2, marginRight: 8 },
  notificationIcon: {
    width: 5,
    height: 5,
    borderRadius: 5 / 2,
    backgroundColor: Colors.coral700,
    marginRight: 4,
  },
  notificationsText: {
    ...Typography.weightRegular,
    fontSize: 12,
    color: Colors.plum300,
  },
});

export default Profiles;
